import { Component, Input } from '@angular/core';
import { PhoneCallAttributes } from '@salesforce/scv-connector-base';

@Component({
  selector: 'app-active-call-attributes',
  templateUrl: './active-call-attributes.component.html',
  styleUrls: ['./active-call-attributes.component.css']
})
export class ActiveCallAttributesComponent {
  @Input() attributes?: PhoneCallAttributes;
}
